import { connect } from "react-redux";
import { selectContentType } from "../../../../state/selectors";
import { BtnStartStopView } from "./BtnStartStop";

const mapStateToProps = (state) => ({
    contentType: selectContentType(state)
});

const mapDispatchToProps = () => ({
});

const BtnStartStop = connect(
    mapStateToProps,
    mapDispatchToProps
)(BtnStartStopView);

export { BtnStartStop };
